import {
  VehicleRegistration,
  VehicleRegistrationHandle,
} from "@/components/booking/create/VehicleRegistration";
import { CreateRequestLayout } from "@/components/customer/CreateRequestLayout";
import React, { useRef } from "react";
import { View } from "react-native";

export default function Step1Screen() {
  const vehicleRegistrationRef = useRef<VehicleRegistrationHandle>(null);

  const handleClickButton = () => {
    vehicleRegistrationRef.current?.submit();
  };

  return (
    <CreateRequestLayout
      title="Tell us about the vehicle"
      subtitle=" Enter the registration to speed things up, or add the vehicle
            details manually."
      onNext={handleClickButton}
      step={1}
      totalSteps={5}
    >
      <View style={{ gap: 12 }}>
        <VehicleRegistration ref={vehicleRegistrationRef} />
      </View>
    </CreateRequestLayout>
  );
}
